/*
Theme Main JS Files
-------------------------------------------*/
import "./components/main";